import { useTheme } from "@/components/context/ThemeContext"
import styles from "./reseller.module.css"
import { CTASection } from "./Reseller/CTASection"
import { HeroSection } from "./Reseller/HeroSection"
import { HowToJoin } from "./Reseller/HowToJoin"
import { ResellerPerks } from "./Reseller/ResellerPerks"


export default function Reseller() {
  const {theme} = useTheme();

  return (
    <main
      className={`${styles.heroSection} ${theme}`}
      style={{ background: 
        `${theme === "dark" ? 
          'linear-gradient(to bottom, rgb(3, 7, 18), rgb(15, 23, 42), rgb(3, 7, 18))':
          'linear-gradient(to bottom, rgb(245, 245, 250), rgb(225, 230, 240), rgb(245, 245, 250))'
        }`
      }}
    >
      <HeroSection />
      <HowToJoin />
      <ResellerPerks />
      <CTASection />
    </main>
  )
}
